export default function capitalizeText(str: string) {
  return str ? str.slice(0, 1).toUpperCase() : "";
}
